/**
 * The rail, ordered the way an edit actually goes.
 *
 * Measurement first, then what is already applied, then the panels in the order
 * a photographer works through them, and history at the bottom where you only
 * go when something has gone wrong.
 */

import { useSelectedPhoto } from '../state/store.ts';
import { Scopes } from './Scopes.tsx';
import { CurvePanel } from './CurveEditor.tsx';
import { EditsPanel } from './panels/EditsPanel.tsx';
import { LooksPanel } from './panels/LooksPanel.tsx';
import { LightPanel } from './panels/LightPanel.tsx';
import { ColorPanel } from './panels/ColorPanel.tsx';
import { DetailPanel } from './panels/DetailPanel.tsx';
import { EffectsPanel } from './panels/EffectsPanel.tsx';
import { GeometryPanel } from './panels/GeometryPanel.tsx';
import { MasksPanel } from './panels/MasksPanel.tsx';
import { HistoryPanel } from './panels/HistoryPanel.tsx';

export function Rail() {
  const photo = useSelectedPhoto();

  if (!photo) {
    return (
      <aside className="rail" aria-label="Adjustments">
        <div className="panel-body">
          <p className="edits-empty">Pick a photo below to start.</p>
        </div>
      </aside>
    );
  }

  return (
    <aside className="rail" aria-label="Adjustments">
      <Scopes />
      <EditsPanel />
      <LooksPanel />
      <LightPanel />
      <ColorPanel />
      <CurvePanel />
      <DetailPanel />
      <EffectsPanel />
      <GeometryPanel />
      <MasksPanel />
      <HistoryPanel />
    </aside>
  );
}
